import { Clear as ClearIcon } from '@mui/icons-material';
import {
  Box,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledCard, StyledCardContent, StyledTypography } from '../styles/styles';
import { ModelActivityLogPageFilters } from './modelActivityLogPageUtils';

interface ModelActivityLogPageFilterPanelProps {
  showFilterPanel: boolean;
  filters: ModelActivityLogPageFilters;
  tone: keyof typeof Palette;
  onFilterChange: (field: keyof ModelActivityLogPageFilters, value: string) => void;
  onClearFilters: () => void;
}

const ModelActivityLogPageFilterPanel: React.FC<ModelActivityLogPageFilterPanelProps> = ({
  showFilterPanel,
  filters,
  tone,
  onFilterChange,
  onClearFilters,
}) => (
  <Collapse in={showFilterPanel}>
    <StyledCard tone={tone} sx={{ mb: 2 }}>
      <StyledCardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <StyledTypography tone={tone} fontSize="1.25rem" fontWeight={600} sx={{ flex: 1 }}>
            Filters
          </StyledTypography>
          <IconButton onClick={onClearFilters} size="small" aria-label="Clear filters">
            <ClearIcon />
          </IconButton>
        </Box>
        <Stack spacing={2}>
          <FormControl fullWidth size="small">
            <InputLabel id="model-activity-log-event-type-label">Event Type</InputLabel>
            <Select
              labelId="model-activity-log-event-type-label"
              id="model-activity-log-event-type"
              value={filters.eventType}
              onChange={(e) => onFilterChange('eventType', e.target.value)}
              label="Event Type"
            >
              <MenuItem value="">All Events</MenuItem>
              <MenuItem value="CONTACT_CREATED">Contact Created</MenuItem>
              <MenuItem value="CONTACT_UPDATED">Contact Updated</MenuItem>
              <MenuItem value="CONTACT_LINK_GENERATED">Contact Link Generated</MenuItem>
              <MenuItem value="LOGIN">Login</MenuItem>
              <MenuItem value="LOGOUT">Logout</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel id="model-activity-log-initiator-type-label">Initiator Type</InputLabel>
            <Select
              labelId="model-activity-log-initiator-type-label"
              id="model-activity-log-initiator-type"
              value={filters.initiatedByType}
              onChange={(e) => onFilterChange('initiatedByType', e.target.value)}
              label="Initiator Type"
            >
              <MenuItem value="">All Types</MenuItem>
              <MenuItem value="CONTACT">Contact</MenuItem>
              <MenuItem value="ADMIN_USER">Admin User</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Start Date"
              type="date"
              value={filters.startDate}
              onChange={(e) => onFilterChange('startDate', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="End Date"
              type="date"
              value={filters.endDate}
              onChange={(e) => onFilterChange('endDate', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        </Stack>
      </StyledCardContent>
    </StyledCard>
  </Collapse>
);

export default ModelActivityLogPageFilterPanel;
